"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = _default;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var React = _interopRequireWildcard(require("react"));
var _componentUtils = require("../../common/componentUtils");
var _gemUrlFormatUtils = require("../../common/utils/domain/gemUrlFormatUtils");
var _formatCommodityData = require("../../utils/formatCommodityData");
require("../../common/style.scss");
var _reportUtil = require("../../utils/reportUtil");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; } /**
 * Created By Gems CLI
 * Issues and merge requests are welcomed：https://git.woa.com/hulk/gems
 *
 * API 参考：
 * http://gems.woa.com/?path=/docs/%E5%BC%80%E5%8F%91-%E4%B8%9A%E5%8A%A1%E7%B4%A0%E6%9D%90%E5%BA%93-%E7%BC%96%E5%86%99%E7%BB%84%E4%BB%B6--page
 */
const _require = require('@tencent/cms-design-component'),
  BuyProduct3 = _require.BuyProduct3;
const formatBuyProduct3 = (properties, options = {}) => {
  const modTitle = properties.modTitle,
    buyType = properties.buyType,
    color = properties.color,
    _properties$list = properties.list,
    list = _properties$list === void 0 ? [] : _properties$list;
  const _getFormatUrlMethods = (0, _gemUrlFormatUtils.getFormatUrlMethods)({
      domains: options === null || options === void 0 ? void 0 : options.domains
    }),
    formatUrlString = _getFormatUrlMethods.formatUrlString,
    formatUrlInText = _getFormatUrlMethods.formatUrlInText;
  const configuration = list.map((item, index) => {
    const title = item.title,
      description = item.description,
      content = item.content,
      butTxt = item.butTxt,
      butHrefBase = item.butHref,
      detailHrefText = item.detailHrefText,
      detailHrefBase = item.detailHref,
      backgroundBigUrl = item.backgroundBigUrl,
      _item$commodityObject = item.commodityObject,
      commodityObject = _item$commodityObject === void 0 ? '{}' : _item$commodityObject,
      isLink = item.isLink;
    const detailHref = formatUrlString(detailHrefBase);
    const butHref = formatUrlString(butHrefBase);
    const resultCommodityObject = (0, _formatCommodityData.formatCommodityData)(commodityObject);
    const itemData = _objectSpread(_objectSpread({
      title,
      description,
      content: formatUrlInText(content),
      but_txt: butTxt,
      isLink,
      but_href: butHref,
      detail_href_text: detailHrefText,
      detail_href: detailHref,
      backgroundBigUrl
    }, resultCommodityObject), {}, {
      extendProps: {
        'report-event': 'click_buyProduct3_button',
        'report-ext1': index,
        'report-ext2': butTxt,
        'report-ext3': butHref
      },
      detailExtendProps: {
        'report-event': 'click_buyProduct3_detail_href',
        'report-ext1': index,
        'report-ext2': detailHrefText,
        'report-ext3': detailHref
      }
    });
    return itemData;
  });
  return {
    modTitle,
    buyType,
    bgColor: color,
    configuration
  };
};
function _default({
  componentKey,
  // {number} 用于标识每一个组件实例的全局唯一且持久化的 key
  data,
  // {object} “数据”表单内容
  style,
  // {object} “样式”表单内容
  commonStyle,
  // {object} “组件自定义样式”表单内容
  global,
  // {object} 页面容器自定义的全局配置项
  meta,
  // {object} 页面元数据
  componentsMap,
  // {Map<number, HTMLElement>} 所有组件 DOM 节点的 Map，key 为组件的 key（number）
  getComponentByKey,
  // {(key: number) => HTMLElement | undefined} 通过组件 key 获取组件 DOM 节点的 API
  store,
  // {object} 组件状态
  on,
  // {(event: string, callback: Function) => void} 事件触发调用
  emit,
  // {(event: string) => void | Promise<void>} 监听事件
  domains: domainInfos
}) {
  const domains = (0, _gemUrlFormatUtils.useDomainGems)({
    domainInfos
  });
  if (Object.keys(data).length > 1) {
    const _formatBuyProduct = formatBuyProduct3(data, {
        domains
      }),
      modTitle = _formatBuyProduct.modTitle,
      buyType = _formatBuyProduct.buyType,
      bgColor = _formatBuyProduct.bgColor,
      configuration = _formatBuyProduct.configuration;
    const bgStyle = bgColor ? (0, _componentUtils.doComponentsBgColorEvent)(bgColor) : {}; // 处理组件背景色

    return /*#__PURE__*/React.createElement("div", Object.assign({
      id: modTitle
    }, (0, _reportUtil.reportShow)(['show_buyProduct3', componentKey, modTitle])), /*#__PURE__*/React.createElement(BuyProduct3, {
      flexTitle: modTitle,
      buyType: buyType,
      configuration: configuration,
      style: bgStyle,
      onCallback: item => {
        window.asyncReceiveCommodity(item);
      }
    }));
  } else {
    return /*#__PURE__*/React.createElement("div", null);
  }
}